/* Copyright (C) mroads, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Premsagar Choudhary <premsagar.choudhary@mroads.com>, February 2022
 * @format
 * @flow
 */

import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import menuVerticalIcon from '../../../../assets/images/Fireboard/action.png';
import CheckCardFooter from './CheckCardFooter';
import modeEnums from '../../../../enums/modeEnums';
import carGreenIcon from "../../../../assets/images/Fireboard/car_green.png";
import carWhiteIcon from "../../../../assets/images/Fireboard/car_white.png";
import classes from './CheckCard.module.css';

const CheckCard = props => {
  const {
    check,
    onSelectCheck,
    currentMode,
    isCheckSelected,
    showPopup,
    onClickCheckFooterButton,
    checkIdsMap,
  } = props;
  const [checkInfo, setCheckInfo] = useState([]);
  const { orders } = check || {};
  const [order0] = orders || [];
  const { vehicleInfo, checkedIn } = order0 || {};

  useEffect(() => {
    if (currentMode === modeEnums.TABLE_DELIVERY) {
      setCheckInfo([
        { value: `Number: ${check?.number}`, numberOfLines: 1 },
        { value: `Name: ${check?.tblDeliveryName}`, numberOfLines: 2 },
        { value: `Deliver To: ${check?.deliverTo}`, numberOfLines: 3 },
        { value: `Time: ${check?.elapsedTimeToDisplay}`, numberOfLines: 1 },
      ]);
    } else if (currentMode === modeEnums.GPS_LOCATION) {
      setCheckInfo([
        { value: `#${check?.number}`, numberOfLines: 2 },
        { value: check?.deliverTo, numberOfLines: 3 },
        { value: check?.elapsedTimeToDisplay, numberOfLines: 1 },
      ]);
    }
  }, [check, currentMode]);

  const onSelectCheckHandler = () => {
    onSelectCheck && onSelectCheck(check);
  };

  const onMenuIconPress = () => {
    showPopup && showPopup('check-actions', check);
  };

  const getBorderColor = () => {
    let borderColor = check?.color || 'white';
    return borderColor;
  };

  const getBackgroundColor = () => {
    let backgroundColor = '#3a3a3a';
    if (currentMode === modeEnums.TABLE_DELIVERY) {
      //if check has vehicleInfo & checkedIn as true - change background color to light green
      if (vehicleInfo && checkedIn) {
        backgroundColor = '#00800025';
      }
      if (checkIdsMap.size > 1 && checkIdsMap.has(check.id)) {
        backgroundColor = '#0000CD25';
      }
    }
    return backgroundColor;
  };

  return (
    <div
      className={classNames({ [classes.checkCardContainer]: true, [classes.highlightedCheckCard]: isCheckSelected })}
      style={{
        backgroundColor: getBackgroundColor(),
        borderColor: getBorderColor(),
      }}
      onClick={onSelectCheckHandler}
    >
      <div className={classes.menuIconWrapper} onClick={onMenuIconPress}>
        <img src={menuVerticalIcon} className={classes.menuIcon} />
      </div>
      <div className={classes.contentWrapper}>
        {checkInfo.map(data => (
          <div
            key={data.value}
            className={classNames({ [classes.dataText]: true, [classes.highlightedText]: isCheckSelected })}
            style={{ WebkitLineClamp: data.numberOfLines }}>
            {data.value}
          </div>
        ))}
      </div>
      <div className={classes.paidImgWrapper}>
        {currentMode === modeEnums.TABLE_DELIVERY && vehicleInfo && (
          <img src={checkedIn ? carGreenIcon : carWhiteIcon} alt='car' className={classes.carImg} />
        )}
        <img src={check.paidStatusIcon} alt='paid' className={classes.paidImg} />
      </div>
      <CheckCardFooter
        mode={currentMode}
        check={check}
        onClickCheckFooterButton={onClickCheckFooterButton}
        isCheckSelected={isCheckSelected}
      />
    </div>
  );
};

export default CheckCard;

CheckCard.propTypes = {
  check: PropTypes.object.isRequired,
  isCheckSelected: PropTypes.bool,
  currentMode: PropTypes.string,
  onSelectCheck: PropTypes.func,
  showPopup: PropTypes.func,
  onClickCheckFooterButton: PropTypes.func,
  checkIdsMap: PropTypes.instanceOf(Map),
};

CheckCard.defaultProps = {
  check: {},
  isCheckSelected: false,
  currentMode: '',
  onSelectCheck: () => { },
  showPopup: () => { },
  onClickCheckFooterButton: () => { },
  checkIdsMap: new Map(),
};
